import { P, Strong } from '@ahmdigital/ui';

import constants from '../../../ahm-constants';

const upgrade = {
  cta: 'Check out black 70 boost',
  id: constants.PRODUCT.BLACK_70_BOOST_EXTRAS,
  title: 'Looking for more services?',
};

export default {
  description: (
    <P>
      You also get <Strong>70%</Strong> back at <Strong>your choice of recognised provider</Strong> on included{' '}
      <Strong>dental</Strong> services, and therapies such as <Strong>physio</Strong> and{' '}
      <Strong>remedial massage</Strong>, plus <Strong>100%</Strong> back on <Strong>optical</Strong>, up to your annual
      limits.
    </P>
  ),
  getSellingPoints: () => [
    {
      description: 'up to your annual limit on included extras.',
      title: '70% back at your choice of recognised provider',
    },
    {
      description: 'Frames, prescription lenses and contact lenses included.',
      title: '100% back on optical',
    },
    {
      description: 'Available at select dentists.',
      title: 'No gap dental check-ups',
    },
  ],
  upgrade,
};
